"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _KESI2BasicComponent = _interopRequireWildcard(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _DrupalListNugget = _interopRequireDefault(require("./DrupalListNugget.scss"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _DrupalNugget = _interopRequireDefault(require("../../../../../targets/cord_sanofi/DrupalNugget.js"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _ListNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/ListNugget"));

var _PageSlide = _interopRequireDefault(require("../../PageSlide/PageSlide"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _DrupalLecture = require("../DrupalLecture");

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'listContainer_';
var INFO_PAGE = 'infoPage';

var DrupalListNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalListNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalListNugget);

  function DrupalListNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalListNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkIfCompletelyRead", function () {
      var nugget = _this.state.content[_this.props.id];
      var completelyRead = true;
      nugget.contents.forEach(function (listItem) {
        var isRead = _KESI2Helper["default"].checkIfContentIsMarkedAsReadInStore(null, listItem.id);

        var isOpened = _this.state.openedNuggets.indexOf(listItem.id) !== -1;
        completelyRead = isRead || isOpened;
      });

      if (completelyRead) {
        _this.props.markAsRead(_this.props.id);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "closeTile", function () {
      return _this.props.closeTile();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "goBack", function () {
      var _document$getElementB;

      _this.setState({
        pageIndex: 0,
        nuggetToShow: null
      });

      _this.props.setBackButtonFunc(_this.closeTile);

      var scrollFrameId = _DrupalLecture.SCROLL_ID;
      (_document$getElementB = document.getElementById(scrollFrameId)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.style.setProperty('overflow-y', 'auto');
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setNuggetId", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(id) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  nuggetToShow: id
                });

                _context.next = 3;
                return (0, _TimeoutHelper.timeout)(200);

              case 3:
                _this.setState({
                  pageIndex: 1
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "openNugget", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(nugget) {
        var _listNugget$contents, _document$getElementB2;

        var openedNuggets, index, listNugget, scrollFrameId;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.setNuggetId(nugget.id);

                openedNuggets = _this.state.openedNuggets;
                index = openedNuggets.indexOf(nugget.id);
                if (index < 0) openedNuggets.push(nugget.id);
                listNugget = _KESI2Helper["default"].getContentById(_this.props.id);
                if ((listNugget === null || listNugget === void 0 ? void 0 : (_listNugget$contents = listNugget.contents) === null || _listNugget$contents === void 0 ? void 0 : _listNugget$contents.length) > 0 && openedNuggets.length === listNugget.contents.length) _this.props.markAsRead(_this.props.id);
                scrollFrameId = _DrupalLecture.SCROLL_ID;
                (_document$getElementB2 = document.getElementById(scrollFrameId)) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.style.setProperty('overflow-y', 'hidden', 'important');

                _this.setState({
                  openedNuggets: openedNuggets
                });

                _this.checkIfCompletelyRead();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    _this.state = _objectSpread({
      pageIndex: 0,
      waitingForActivation: false,
      nuggetToShow: null,
      openedNuggets: []
    }, _this.state);
    _this.active = true;

    _this.props.registerNugget(_this.props.id, _ListNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalListNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalListNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _ListNugget["default"].CLASS, this.getDomId());
      this.checkIfCompletelyRead();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalListNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join('!')), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join('!')] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _document$getElementB3,
          _nugget$contents,
          _this2 = this;

      /**
       * @type {ListNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var scrollFrameId = _DrupalLecture.SCROLL_ID;
      var top = ((_document$getElementB3 = document.getElementById(scrollFrameId)) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.scrollTop) || 0;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "listContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        id: "listContainer",
        className: "listNugget_".concat(this.props.id)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "listNuggetContainer ".concat(nugget.title && nugget.show_title ? '' : 'extraPadding')
      }, /*#__PURE__*/_react["default"].createElement(_PageSlide["default"], {
        index: this.state.pageIndex,
        showBottomBar: _config["default"].showBottomBar,
        isInNuggetContainer: true,
        height: 'auto',
        topPositionOnExtraPages: top
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative'
        }
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.show_title && /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.inGalleryContainer ? 'titleSmall' : 'title'
      }, nugget.title), ((_nugget$contents = nugget.contents) === null || _nugget$contents === void 0 ? void 0 : _nugget$contents.length) > 0 && nugget.contents.map(function (nugget) {
        var nuggetContent = _KESI2Helper["default"].getContentById(nugget.id);

        if (!nuggetContent) return null;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: nugget.id,
          className: "".concat(_DrupalListNugget["default"].listItem, " listNuggetListItem"),
          style: {
            backgroundColor: _this2.props.forcedUIColor ? _this2.props.forcedUIColor : _cssConstants["default"].colors.navbarBackground
          },
          onClick: function onClick() {
            return _this2.openNugget(nugget);
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalListNugget["default"].listArrow
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalListNugget["default"].listTitle
        }, nuggetContent.title), _config["default"].showArrowOnTile || _config["default"].showArrowInListNugget && /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalListNugget["default"].tileArrow,
          style: {
            height: '45px',
            width: '45px'
          }
        }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement("img", {
          style: {
            height: '30px',
            width: '30px',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)'
          },
          src: _config["default"].arrowRight
        }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          style: {
            height: '30px',
            width: '30px',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)'
          },
          name: 'chevron-right'
        })), _this2.state.openedNuggets && _KESI2Helper["default"].checkIfContentIsMarkedAsReadInStore(nugget, nugget.id) && /*#__PURE__*/_react["default"].createElement(_Done["default"], {
          className: _DrupalListNugget["default"].checkIcon
        }));
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalListNugget["default"].infoContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: INFO_PAGE,
        className: _DrupalListNugget["default"].infoPage
      }, this.state.nuggetToShow ? /*#__PURE__*/_react["default"].createElement(_DrupalNugget["default"], {
        id: this.state.nuggetToShow,
        path: this.props.path,
        registerNugget: this.props.registerNugget,
        markAsRead: this.props.markAsRead,
        contentPathArray: this.props.contentPathArray,
        setBackButtonFunc: this.props.setBackButtonFunc,
        inListContainer: true,
        goUpFunc: this.goBack
      }) : null))))));
    }
  }]);
  return DrupalListNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalListNugget;
DrupalListNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  closeTile: _propTypes["default"].func,
  setBackButtonFunc: _propTypes["default"].func,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  forcedUIColor: _propTypes["default"].string,
  renderIcon: _propTypes["default"].func.isRequired
};
DrupalListNugget.defaultProps = {
  id: null
};